export interface ProductType {
  id: string;
  description: string;
  userDescription: string;
  unitOfMeasure: string;
  obsolete: string;
}
